import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSImageFits, EGDSRoundcorners } from '../types/index.esm.js';
import styles from '../../styles/uitk-egds-images.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { validatePropType } from '../../utils/validate-prop-types/index.esm.js';
const getClassNameList = classNames.bind(styles);
var EGDSFigureAspectRatioType;
(function (EGDSFigureAspectRatioType) {
  EGDSFigureAspectRatioType["R1_1"] = "ratio-1-1";
  EGDSFigureAspectRatioType["R4_3"] = "ratio-4-3";
  EGDSFigureAspectRatioType["R3_2"] = "ratio-3-2";
  EGDSFigureAspectRatioType["R16_9"] = "ratio-16-9";
  EGDSFigureAspectRatioType["R21_9"] = "ratio-21-9";
  EGDSFigureAspectRatioType["R3_4"] = "ratio-3-4";
  EGDSFigureAspectRatioType["R4_1"] = "ratio-4-1";
})(EGDSFigureAspectRatioType || (EGDSFigureAspectRatioType = {}));
class EGDSFigure extends React.Component {
  static displayName = 'EGDSFigure';
  static AspectRatio = EGDSFigureAspectRatioType;
  render() {
    const {
      className,
      children,
      ratio,
      src,
      roundcorner,
      imageFit,
      additionalProps,
      style
    } = this.props;
    const Tag = src ? 'div' : 'figure';
    const handleRoundcornerClassArray = (classArr, propArr, baseClass) => {
      propArr.forEach(arrayValue => classArr.push(`${baseClass}-${EGDSRoundcorners.get(arrayValue)}`));
    };
    const roundcornerClass = prop => {
      const roundcornerBaseClass = 'uitk-image-roundcorner';
      const propType = typeof prop;
      const classArr = [];
      const propIsArray = Array.isArray(prop);
      if (propType === 'boolean') {
        // Prop type is boolean
        classArr.push(`${roundcornerBaseClass}-all`);
      } else if (propIsArray) {
        // Prop type is array
        handleRoundcornerClassArray(classArr, prop, roundcornerBaseClass);
      } else {
        // Prop type is object
        const object = prop;
        Object.getOwnPropertyNames(object).forEach(breakpointKey => {
          const breakRoundcornerBaseClass = `${roundcornerBaseClass}-${breakpointKey}`;
          if (Array.isArray(object[breakpointKey])) {
            handleRoundcornerClassArray(classArr, object[breakpointKey], breakRoundcornerBaseClass);
          } else {
            // UitkRoundcornerBreakSetting type
            const cornerObject = object[breakpointKey];
            Object.getOwnPropertyNames(cornerObject).forEach(cornerKey => {
              if (cornerObject[cornerKey] === 'set') {
                classArr.push(`${breakRoundcornerBaseClass}-${EGDSRoundcorners.get(cornerKey)}`);
              } else if (cornerObject[cornerKey] === 'unset') classArr.push(`${breakRoundcornerBaseClass}-${EGDSRoundcorners.get(cornerKey)}-unset`);
            });
          }
        });
      }
      return classArr;
    };
    const classList = getClassNameList('uitk-image', className, roundcorner && roundcornerClass(roundcorner), imageFit && `uitk-image-${EGDSImageFits.get(imageFit)}`, {
      [`uitk-image-${ratio}`]: validatePropType(ratio, EGDSFigureAspectRatioType),
      'uitk-image-ratio': validatePropType(ratio, EGDSFigureAspectRatioType)
    }, {
      [`uitk-image-ratio-2-1`]: !ratio,
      'uitk-image-ratio': !ratio,
      'uitk-image-background': src
    });
    let cssStyle = {};
    if (style) {
      cssStyle = style;
    } else if (src) {
      cssStyle = {
        backgroundImage: `url("${src}")`
      };
    }
    const newProps = {
      className: classList,
      style: cssStyle,
      ...additionalProps
    };
    return jsx(Tag, {
      ...newProps,
      children: children
    });
  }
}
export { EGDSFigure, EGDSFigureAspectRatioType };